import { FilterFieldGroup } from '@App/forms/common/filter-field-group'
import React from 'react'
import { FormFieldTypes } from '@App/enum/form-field-types'
import StatusComponent from '@Components/Status'
import { SUGGESTION_STATUS_VALUES } from '@Components/MatchComponents/v2/suggestion-status'
import { SearchPanelSortOption } from '@Components/Search/SearchPanel/types'

export interface RegistrationHistoryFilter {
    workHistoryStatusFilter?: RegistrationHistoryStatusTypes[]
    workHistorySourceFilter?: RegistrationHistorySourceTypes[]
    workHistoryOverclaimFilter?: RegistrationHistoryOverclaimTypes[]
    sort_by?: RegistrationHistorySortByTypes
}
export type RegistrationHistoryStatusTypes = 'processing' | 'accepted' | 'rejected' | 'superseded'
export type RegistrationHistorySourceTypes = 'cwr' | 'esong' | 'mlc'
export type RegistrationHistoryOverclaimTypes = 'has_open_overclaims'
export type RegistrationHistorySortByTypes = 'submission_date' | 'last_update_date'

export const registrationHistoryStatusFilterGroup: FilterFieldGroup<RegistrationHistoryFilter> = {
    name: 'Submission Status',
    allowMultiple: true,
    filterFields: [
        {
            workHistoryStatusFilter: {
                name: 'workHistoryStatusFilter',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'accepted',
                        label: 'Accepted',
                        children: <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.ACCEPTED} big />,
                    },
                    {
                        id: 'rejected',
                        label: 'Rejected',
                        children: <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.REJECTED} big />,
                    },
                    {
                        id: 'superseded',
                        label: 'Superseded',
                        children: (
                            <StatusComponent withCount={false} status={SUGGESTION_STATUS_VALUES.SUPERSEDED} big />
                        ),
                    },
                ],
            },
        },
    ],
}

export const registrationHistorySourceFilterGroup: FilterFieldGroup<RegistrationHistoryFilter> = {
    name: 'Submission Source',
    allowMultiple: true,
    filterFields: [
        {
            workHistorySourceFilter: {
                name: 'workHistorySourceFilter',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'cwr',
                        label: 'CWR',
                        children: <strong> CWR </strong>,
                    },
                    {
                        id: 'esong',
                        label: 'eSong',
                        children: <strong> eSong </strong>,
                    },
                    {
                        id: 'mlc',
                        label: 'The MLC',
                        children: <strong> The MLC </strong>,
                    },
                ],
            },
        },
    ],
}

export const registrationHistoryOverclaimFilterGroup: FilterFieldGroup<RegistrationHistoryFilter> = {
    name: 'Overclaim Status',
    allowMultiple: true,
    filterFields: [
        {
            workHistoryOverclaimFilter: {
                name: 'workHistoryOverclaimFilter',
                label: '',
                type: FormFieldTypes.CHECKBOX_GROUP,
                checkboxes: [
                    {
                        id: 'has_open_overclaims',
                        label: 'Has Open Overclaims',
                        children: <strong> Has Open Overclaims </strong>,
                    },
                ],
            },
        },
    ],
}

// Single source of truth for the sort options, shared by the filter-sidebar radio group below
// and the SearchPanel SortBy dropdown (kept in sync via sortFilterKey="sort_by" on SearchPanel).
const registrationHistorySortValues: Array<{
    value: RegistrationHistorySortByTypes
    label: string
    default?: boolean
}> = [
    { value: 'submission_date', label: 'Submission Date' },
    { value: 'last_update_date', label: 'Last Updated', default: true },
]

export const registrationHistorySortFilterGroup: FilterFieldGroup<RegistrationHistoryFilter> = {
    name: 'Sort',
    allowMultiple: false,
    filterFields: [
        {
            SORT: {
                type: FormFieldTypes.RADIO,
                options: registrationHistorySortValues.map(({ value, label, default: isDefault }) => ({
                    name: value,
                    label,
                    default: isDefault,
                })),
                name: 'sort_by',
                label: '',
                children: <strong> Submission Date </strong>,
            },
        },
    ],
}

export const registrationHistorySortOptions: SearchPanelSortOption[] = registrationHistorySortValues.map(
    ({ value, label }) => ({ value, label })
)

export const RegistrationHistoryFilterCollection: Array<FilterFieldGroup<RegistrationHistoryFilter>> = [
    registrationHistoryStatusFilterGroup,
    registrationHistorySourceFilterGroup,
    registrationHistoryOverclaimFilterGroup,
    registrationHistorySortFilterGroup,
]
